import { mdiHelp } from '@mdi/js';
import Icon from '@mdi/react';
import HeaderButton from 'components/layouts/components/Header/HeaderButton';
import React from 'react';
import { Tooltip } from 'antd';
import UrlHelper from 'common/utils/url-helper';

const Helper = () => {
  const handleClick = (_) => {
    window.open(UrlHelper.home('/blog/', { category: 'tutorials' }), '_blank');
  };

  return (
    <Tooltip title='View the tutorials'>
      <HeaderButton color='darkText' onClick={handleClick}>
        <Icon path={mdiHelp} />
      </HeaderButton>
    </Tooltip>
  );
};

export default Helper;
